<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      id: null,
      name: '',
      description: '',
      manager_id: '',
      managers: [],
      errors: {},
    };
  },
  mounted() {
    this.fetchManagers();
  },
  methods: {
    async fetchManagers() {
      try {
        const res = await axios.get('/hrms/employees/manager');
        this.managers = res.data.data || [];
      } catch (error) {
        console.log(error.message);
      }
    },

    add() {
      this.resetForm();
    },

    edit(dept) {
      this.resetForm();
      this.id = dept.id;
      this.name = dept.name;
      this.description = dept.description || '';
      this.manager_id = dept.manager_id || '';
    },

    setDelete(dept) {
      this.id = dept.id;
    },

    async save() {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = {
          name: this.name,
          description: this.description || null,
          manager_id: this.manager_id || null,
        };
        let response;
        if (this.id) {
          response = await axios.put(`/hrms/departments/${this.id}`, payload);
        } else {
          response = await axios.post('/hrms/departments', payload);
        }
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_department_modal');
        this.resetForm();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async deleteDepartment() {
      this.setLoading(true);
      try {
        const response = await axios.delete(`/hrms/departments/${this.id}`);
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_department_delete_modal');
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
          this.$swalToast(error.errors?.id?.[0] || error.message, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.id = null;
      this.name = '';
      this.description = '';
      this.manager_id = '';
      this.errors = {};
    },
  },
};
</script>

<template>
  <!-- Add/Edit Modal -->
  <div class="modal fade" id="hrm_department_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Department</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">
            <div class="mb-3">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="name" placeholder="Enter department name" />
              <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
            </div>

            <div class="mb-3">
              <label class="form-label">Department Manager</label>
              <select class="form-select" v-model="manager_id">
                <option value="">Select manager</option>
                <option v-for="m in managers" :key="m.id" :value="m.id">{{ m.full_name }}</option>
              </select>
              <div v-if="errors.manager_id" class="text-danger small mt-1">{{ errors.manager_id[0] }}</div>
            </div>

            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="3" v-model="description" placeholder="Enter description (optional)"></textarea>
              <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary">{{ id ? 'Update' : 'Save' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="hrm_department_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">You want to delete this department? This can't be undone.</p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteDepartment">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>